"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageDescription = void 0;
var imageDescription = 'Image with additional fields: Click on the pencil icon in the upper right corner to add an alt text for it or to define the color of the text on it';
exports.imageDescription = imageDescription;
